import { atom } from 'jotai';
import type { User, Session } from '@supabase/supabase-js';
import type { Database } from '../lib/supabase';
import type { SubscriptionUsageWithDetails } from '../lib/subscriptions';

type Profile = Database['public']['Tables']['profiles']['Row'];

// Core auth atoms
export const userAtom = atom<User | null>(null);
export const sessionAtom = atom<Session | null>(null);
export const profileAtom = atom<Profile | null>(null);
export const authLoadingAtom = atom<boolean>(true);
export const authErrorAtom = atom<string | null>(null);
export const isRecoverySessionAtom = atom<boolean>(false);

// Subscription usage atom for global credits state
export const subscriptionUsageAtom = atom<SubscriptionUsageWithDetails | null>(null);

// Loading state for subscription/credits data
export const subscriptionLoadingAtom = atom<boolean>(false);

// Derived atom for credits display (subscription credits or profile credits)
export const creditsDisplayAtom = atom<number>((get) => {
  const subscriptionUsage = get(subscriptionUsageAtom);
  const profile = get(profileAtom);
  
  if (subscriptionUsage?.credits_remaining !== undefined && subscriptionUsage.credits_remaining !== null) {
    return subscriptionUsage.credits_remaining;
  }
  
  return profile?.credits ?? 0;
});

// Derived atom for credits included in subscription
export const creditsIncludedAtom = atom<number>((get) => {
  const subscriptionUsage = get(subscriptionUsageAtom);
  return subscriptionUsage?.credits_included ?? 0;
});

// Derived atom for credits used this period
export const creditsUsedAtom = atom<number>((get) => {
  const subscriptionUsage = get(subscriptionUsageAtom);
  return subscriptionUsage?.credits_used ?? 0;
});
